import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
import { pluck } from 'rxjs/operators';
import { MasterRequests } from '../models/master-requests';
const addMasterRequestsMutation = gql`mutation insert_master_requests_one($master_requests: master_requests_insert_input!){
  insert_master_requests_one(object: $master_requests){
    id
  }
}`
@Injectable({
  providedIn: 'root'
})
export class AddMasterRequestsService {

/* ------------------------------- Constructor ------------------------------ */

  constructor(private apollo: Apollo) { }

/* --------------------------- Add Master Requests -------------------------- */

  addMasterRequests(master_requests: MasterRequests) : Promise<string>{
    return this.apollo.mutate({
      mutation: addMasterRequestsMutation,
      variables: {
          master_requests
      }
    }).pipe(pluck("data", "insert_master_requests_one", "id")).toPromise() as Promise<string> ;
  }
}
